import { render, staticRenderFns } from "./menusListFilters.vue?vue&type=template&id=0f0b2144&"
import script from "./menusListFilters.vue?vue&type=script&lang=js&"
export * from "./menusListFilters.vue?vue&type=script&lang=js&"
import style0 from "./menusListFilters.vue?vue&type=style&index=0&id=0f0b2144&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports